import type { HTMLAttributes, MouseEvent } from 'react'
import styled from 'styled-components'
import { CopyIcon } from 'icons'
import copy from 'copy.json'
import { classNames } from 'utils'

type Props = {
  value: string
} & HTMLAttributes<HTMLButtonElement>

export default function CopyButton({
  value = '',
  className,
  children = copy.common.button.copy,
  onClick,
  ...props
}: Props) {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    window.navigator.clipboard.writeText(value)
    onClick?.(event)
  }

  return (
    <Button
      type="button"
      className={classNames('green', 'text', className)}
      onClick={handleClick}
      {...props}
    >
      <CopyIcon />
      {children}
    </Button>
  )
}

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`
